import fetch from 'isomorphic-unfetch';

export const getUpstreamVaryHeaders = (response) => ({
  'x-bf-vary': response.headers?.get?.('x-bf-vary') || '',
  vary: response.headers?.get?.('vary') || '',
});

export const applyUpstreamVaryHeaders = (res, upstreamVaryHeaders = {}) => {
  if (!res?.setHeader) {
    return;
  }

  const xBfVary = upstreamVaryHeaders['x-bf-vary'] || upstreamVaryHeaders.vary;
  const vary = upstreamVaryHeaders.vary || upstreamVaryHeaders['x-bf-vary'];

  if (xBfVary) {
    res.setHeader('X-BF-Vary', xBfVary);
  }
  if (vary) {
    res.setHeader('Vary', vary);
  }
};

export const fetchAPI = async (uri, { req, includeHeaders = false }) => {
  const baseUrl = req ? `http://localhost:${process.env.PORT}` : '';
  const fetchOpts = req ? { headers: req.headers } : {};

  try {
    const response = await fetch(`${baseUrl}${uri}`, fetchOpts);
    if (!response.ok) {
      let error = await response.text();
      try {
        error = JSON.parse(error).message;
      } catch {
        // silently catch parse errors here and use text below
      }

      return { error: { error, statusCode: response.status } };
    }

    const body = await response.json();

    return includeHeaders
      ? { ...body, upstreamResponseHeaders: getUpstreamVaryHeaders(response) }
      : body;
  } catch (e) {
    return {
      error: { error: e.message || 'Error fetching API data', statusCode: 500 },
    };
  }
};
